// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.court-section h4 {
  margin-bottom: 0.5rem;
}

.court-section ul {
  margin-bottom: 0.5rem;
}

.client-cases {
  margin-top: 2rem;
}
.client-cases .caseids {
  cursor: pointer;
}
.client-cases h3 {
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}
.client-cases ul {
  padding-left: 1rem;
  list-style-type: disc;
}
.client-cases ul li {
  color: var(--text-dark);
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}

.court-section:not(:first-child) {
  margin-top: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/ViewLabel/ViewLabel.scss"],"names":[],"mappings":"AACA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAIA;EACE,gBAAA;AADF;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;AADJ;AAIE;EACE,kBAAA;EACA,qBAAA;AAFJ;AAII;EACE,uBAAA;EACA,kBAAA;EACA,sBAAA;AAFN;;AAQA;EACE,mBAAA;AALF","sourcesContent":["// Add spacing between headings and lists, and between court sections\n.court-section h4 {\n  margin-bottom: 0.5rem;\n}\n\n.court-section ul {\n  margin-bottom: 0.5rem;\n}\n\n// Add equal spacing before each court section except the first\n.client-cases  {\n  margin-top: 2rem;\n  .caseids{\n    cursor: pointer;\n  }\n\n  h3 {\n    font-size: 1.125rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: var(--text-dark);\n    margin-bottom: 0.5rem;\n  }\n\n  ul {\n    padding-left: 1rem;\n    list-style-type: disc;\n\n    li {\n      color: var(--text-dark);\n      font-size: 0.95rem;\n      margin-bottom: 0.25rem;\n    }\n  }\n}\n\n// Add equal top margin to all court sections except the first\n.court-section:not(:first-child) {\n  margin-top: 0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
